// Función para validar tarjetas de crédito
export const validateCreditCard = (cardNumber) => {
  // Eliminar espacios y guiones
  const cleanNumber = cardNumber.replace(/[\s-]/g, '');
  
  // Verificar que solo contenga dígitos y tenga longitud válida
  if (!/^\d+$/.test(cleanNumber) || cleanNumber.length < 13 || cleanNumber.length > 19) {
    return {
      valid: false,
      cardType: 'Desconocido'
    };
  }
  
  // Algoritmo de Luhn (módulo 10)
  let sum = 0;
  let shouldDouble = false;
  
  // Recorrer de derecha a izquierda
  for (let i = cleanNumber.length - 1; i >= 0; i--) {
    let digit = parseInt(cleanNumber.charAt(i));
    
    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    
    sum += digit;
    shouldDouble = !shouldDouble;
  }
  
  const valid = (sum % 10) === 0;
  
  // Determinar el tipo de tarjeta basado en el prefijo
  let cardType = 'Desconocido';
  
  if (/^4/.test(cleanNumber)) {
    cardType = 'Visa';
  } else if (/^5[1-5]/.test(cleanNumber)) {
    cardType = 'Mastercard';
  } else if (/^3[47]/.test(cleanNumber)) {
    cardType = 'American Express';
  } else if (/^6(?:011|5)/.test(cleanNumber)) {
    cardType = 'Discover';
  }
  
  return {
    valid,
    cardType
  };
};

// Validar email
export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

// Validar contraseña (mínimo 8 caracteres, al menos una letra y un número)
export const validatePassword = (password) => {
  const re = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
  return re.test(String(password));
};

// Validar BIN (solo números y 'x')
export const validateBinInput = (bin) => {
  return /^[0-9x]{6,16}$/i.test(bin);
};

export default {
  validateCreditCard,
  validateEmail,
  validatePassword,
  validateBinInput
};